import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { legalPages, siteConfig, AFFILIATE_URL } from '../data/mock';
import { ArrowLeft } from 'lucide-react';

const LegalPage = () => {
  const location = useLocation();
  const page = location.pathname.substring(1); // Remove leading slash
  const pageData = legalPages[page];

  if (!pageData) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Page Not Found</h1>
            <Link to="/" className="text-blue-600 hover:underline">Return to Home</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  // Handle click on entire page to open affiliate link
  const handlePageClick = (e) => {
    // Don't trigger for footer links or back button
    if (e.target.closest('footer') || e.target.closest('a') || e.target.closest('button')) {
      return;
    }
    window.open(AFFILIATE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen flex flex-col bg-white" onClick={handlePageClick}>
      <Header />
      
      <main className="flex-1 py-12">
        <div className="max-w-3xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center text-gray-600 hover:text-[#cc0000] mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-8 border-b pb-4">
            {pageData.title}
          </h1>
          
          <div className="prose max-w-none">
            {pageData.content.split('\n\n').map((paragraph, index) => {
              // Check if it's a header (all caps or starts with specific keywords)
              if (paragraph === paragraph.toUpperCase() && paragraph.length < 100) {
                return (
                  <h2 key={index} className="text-xl font-bold text-gray-800 mt-8 mb-4">
                    {paragraph}
                  </h2>
                );
              }
              return (
                <p key={index} className="text-gray-600 mb-4 whitespace-pre-line">
                  {paragraph}
                </p>
              );
            })}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LegalPage;